import { render, staticRenderFns } from "./activity-cards.vue?vue&type=template&id=1347ce94&scoped=true&"
import script from "./activity-cards.vue?vue&type=script&lang=js&"
export * from "./activity-cards.vue?vue&type=script&lang=js&"
import style0 from "./activity-cards.vue?vue&type=style&index=0&id=1347ce94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347ce94",
  null
  
)

export default component.exports